import { capitalize } from "client/utils/capitalize";
import { translateFunc } from "client/utils/translateFunc";
import { Input } from "components/common/Input/Input";
import { Select } from "components/common/Select/Select";
import { Translate } from "components/common/Translate/Translate";
import { fileUnits } from "store/features/bulkResize/types";
import { type ImageExtension, imageExtensions } from "store/types/imageExtension";
import { useExportSettings } from "./useExportSettings";

export const ExportSettings = () => {
    const {
        fileUnit,
        maxFileSize,
        optimizationLevel,
        saveAs,
        handleMaxFileSizeChange,
        handleFileUnitChange,
        handleSaveAsChange,
    } = useExportSettings();

    const getExtensionLabel = (option: ImageExtension) =>
        option === "original" ? translateFunc("original") : capitalize(option.replace(".", "")).toUpperCase();

    return (
        <div>
            <div className="px-4 text-black dark:text-white">
                {optimizationLevel === "custom" && (
                    <>
                        <div className="mt-4" data-testid={`max-file-size-label`}>
                            <span className="font-semibold capitalize">
                                <Translate keyName="target-file-size-label" />
                            </span>{" "}
                            <span className="text-irGray-600">({translateFunc("optional")})</span>
                        </div>
                        <div className="flex items-center pt-2 pb-2">
                            <Input
                                className="flex-grow py-6 border-r-0 rounded-r-none"
                                type="number"
                                value={maxFileSize > 0 ? maxFileSize : ""}
                                onChange={(e) => handleMaxFileSizeChange(+e.target.value)}
                                data-testid={`max-file-size-input`}
                            />
                            <Select
                                options={fileUnits.map((f) => f)}
                                value={fileUnit}
                                getOptionValue={(value) => value}
                                getOptionLabel={(value) => value}
                                handleClick={handleFileUnitChange}
                                testKey={`max-file-size-unit`}
                            />
                        </div>
                        <div className="text-sm text-irGray-600">{translateFunc("target-file-size-desc")}</div>
                    </>
                )}

                <div className="py-2 mt-4">
                    <Select
                        options={[...imageExtensions]}
                        value={saveAs}
                        label={capitalize(translateFunc("extension-label"))}
                        getOptionLabel={getExtensionLabel}
                        getOptionValue={(option) => option}
                        handleClick={handleSaveAsChange}
                        labelClassNames="font-semibold lg:font-normal"
                        testKey={`extension`}
                    />
                </div>
            </div>
        </div>
    );
};
